// extracted by mini-css-extract-plugin
module.exports = {"alert":"Message__alert___1BEO-","notice":"Message__notice___1TQ-r","layouts_message_fadeout":"Message__layouts_message_fadeout___2biLM"};